import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const toggleSidebar = createAction(types.TOGGLE_SIDEBAR);
export const changeSystemStatus = createAction(types.CHANGE_SYSTEM_STATUS);
export const byPassMaintenanceMode = createAction(
  types.BY_PASS_MAINTENANCE_MODE,
);

export default {
  toggleSidebar,
  changeSystemStatus,
  byPassMaintenanceMode,
};
